import CreateMultipleDonations from './CreateMultipleDonations'
export default CreateMultipleDonations
